<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="bankDetailFormGroup">
    <div class="clearfix mxn2">
      <div class="col col-6">
        <div class="py2">
          <app-element-slide-toggle
            [formControlName]="controls.IsThirdPartyAccount"
            [label]="'Is A Third Party Account'">
          </app-element-slide-toggle>
        </div>
      </div>

      <div class="col col-6">
        <mat-form-field>
          <mat-label>Usage</mat-label>
          <mat-select [formControlName]="controls.Usage">
            <mat-option
              *ngFor="let usage of usages"
              [disabled]="isUsageOptionDisabled(usage.key)"
              [value]="usage.key">
              {{ usage.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>


    <div class="clearfix mxn2">
      <div class="col col-6">
        <mat-form-field>
          <mat-label>Bank Account Type</mat-label>
          <mat-select [formControlName]="controls.BankAccountType">
            <mat-option *ngFor="let bankAccountType of bankAccountTypes" [value]="bankAccountType.key">
              {{ bankAccountType.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col col-6">
        <mat-form-field>
          <mat-label>Bank Name</mat-label>
          <mat-select [formControlName]="controls.BankCode"
                      (selectionChange)="onBankSelectionChanged($event.source.value)">
            <mat-option *ngFor="let bankCode of bankCodes" [value]="bankCode.key">
              {{ bankCode.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="clearfix mxn2">
      <div class="col col-6">
        <app-element-input
          [cssClasses]="['w-90']"
          [customErrorMessages]="DisplayStrings.branchCodeMessages"
          [customValidators]="[CustomValidator.SABranchCodeValidator]"
          [formControlName]="controls.BranchCode"
          [label]="'Branch Code'"
          [required]="true">
        </app-element-input>
      </div>
      <div class="col col-6">
        <app-element-input
          [cssClasses]="['w-90']"
          [customErrorMessages]="DisplayStrings.customValidatorsList"
          [customValidators]="[CustomValidator.numeric, CustomValidator.atLeastOneValue]"
          [formControlName]="controls.AccountNumber"
          [label]="'Account number'"
          [required]="true">
        </app-element-input>
      </div>
    </div>

    <div class="clearfix mxn2">
      <div class="col col-6">
        <app-element-input
          [cssClasses]="['w-90']"
          [formControlName]="controls.AccountName"
          [label]="'Account Name'"
          [required]="true">
        </app-element-input>
      </div>

      <div class="col col-6">
        <mat-form-field *ngIf="showDebitOrderDate">
          <mat-label>Debit Order Day</mat-label>
          <mat-select [formControlName]="controls.DebitOrderDay">
            <mat-option *ngFor="let debitOrderDay of debitOrderDays" [value]="debitOrderDay.key">
              {{ debitOrderDay.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button (click)="onCancel()" class="dialog-button" color="warn" mat-raised-button>Cancel</button>
  <button (click)="onSave()" [disabled]="!bankDetailFormGroup.valid" class="dialog-button"
          color="primary"
          mat-raised-button>
    Save
  </button>
</mat-dialog-actions>
